import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant, isUserBuyerGroup } from "@/js/http/auth";
import { orderStatus } from "@/js/lists.ts";
import Error from "@/views/error/error.vue";
import AdminOrderSummary from "@/components/order/AdminOrderSummary.vue";
import AdminOrdersSubMenusLinks from "@/components/menu/sub-menus/orders/AdminOrdersSubMenusLinks.vue";
export default {
  name: "AdminOrderView",
  props: ["loggedUserData"],
  data: function data() {
    return {
      id_order: null,
      order: null,
      isDataLoading: true,
      error: {
        title: "order not found",
        link: "",
        linkTitle: "to orders",
        params: {
          tab: "orders"
        }
      }
    };
  },
  created: function created() {
    this.id_order = this.$route.params.id;
    this.error.link = isUserBuyerGroup(this.loggedUserData) ? "userOrderList" : "adminOrderList";
    this.getOrder();
  },
  components: {
    AdminOrderSummary: AdminOrderSummary,
    AdminOrdersSubMenusLinks: AdminOrdersSubMenusLinks,
    Error: Error
  },
  methods: {
    getOrder: function getOrder() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this, response, isCart;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this = _this2;
              _context.next = 3;
              return request("/v1/order/" + _this.id_order, "get", null, true, "api").catch(function (e) {
                _this.isDataLoading = false;
                throw e;
              });
            case 3:
              response = _context.sent;
              isCart = response.data.status === orderStatus.find(function (x) {
                return x.id == "CREATED";
              }).status;
              if (!isCart) {
                _this2.order = _objectSpread({}, response.data);
              }
              _this2.isDataLoading = false;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};